import { createContentHook } from './createContentHook';
import type { AboutYageoGroupOverviewContent } from '../types/AboutYageoGroupOverviewContent';

export const useAboutYageoGroupOverviewContent = createContentHook<AboutYageoGroupOverviewContent>(
    '/About/YageoGroupOverview'
);
